import {
  Box,
  Button,
  Divider,
  Heading,
  Image,
  Link,
  Stack,
  Tag,
  Text,
  AspectRatio,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { sponsor_link_clicked } from '@/analytics';
import { Card } from '@/imports/ui/chakra/components/Card';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';
import { getExternalUrl } from '@/utilities/getExternalUrl';

import { PublishButton } from './components/PublishButton';

export const SponsorPagePromotionCard: React.FC<{
  image?: string;
  title: string;
  body: string;
  callToAction: string;
  url: string;
  isEditable?: boolean;
  published?: boolean;
  adId?: string;
  organizationId?: string;
  organizationName?: string;
  sponsorTier?: string;
}> = ({
  image,
  title,
  body,
  callToAction,
  url,
  isEditable,
  published = true,
  adId,
  organizationId,
  organizationName,
  sponsorTier,
}) => {
  const fullUrl = getExternalUrl(url);

  const trackClick = () => {
    if (!organizationId) return;

    sponsor_link_clicked({
      entity_type: 'sponsor_link',
      entity_id: organizationId,
      sponsor_id: organizationId,
      sponsor_name: organizationName,
      sponsor_tier: sponsorTier,
      sponsor_cta_text: callToAction,
      sponsor_link_type: 'sponsor_page_promotion',
      sponsor_destination_url: fullUrl || '',
      sponsor_interaction_source: 'sponsor_detail',
      is_sponsor_interaction: true,
    });
  };

  return (
    <Card p="6" textAlign="center">
      <Stack spacing="4">
        <Stack spacing="1">
          <Stack spacing="4">
            <Box position="relative">
              {image ? (
                <AspectRatio ratio={1}>
                  <Image alt={title} src={image} borderRadius="base" objectFit="contain" />
                </AspectRatio>
              ) : (
                <ImageFallback aspectRatio="1" borderRadius="base" />
              )}
              {!published && (
                <Tag
                  variant="solid"
                  colorScheme="gray"
                  position="absolute"
                  top={2}
                  right={2}
                >
                  Not Published
                </Tag>
              )}
            </Box>
            <Heading size="sm" color="gray.700">
              {title}
            </Heading>
          </Stack>
          <Text color="gray.500">{body}</Text>
        </Stack>
        <Button
          as="a"
          variant="outline"
          colorScheme="gray"
          href={fullUrl}
          target="_blank"
          rel="noopener noreferrer"
          w="full"
          onClick={trackClick}
        >
          {callToAction}
        </Button>
        {isEditable && (
          <Stack spacing="4">
            <Divider />
            {!published && adId && <PublishButton adId={adId} />}
            <Link as={NextLink} href="/my-company/promotion">
              Edit Promotion
            </Link>
          </Stack>
        )}
      </Stack>
    </Card>
  );
};
